import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'platfrom-confirm-dialog',
    templateUrl: './platfrom-confirm-dialog.component.html',
    styleUrls: ['./platfrom-confirm-dialog.component.scss']
})
export class PlatfromConfirmDialogComponent {
    public confirmMessage: string;

    constructor(public dialogRef: MatDialogRef<PlatfromConfirmDialogComponent>) {
    }

}
